import React, { useState } from "react";

import css from "./HomePage.module.css";
import { Head } from "../../Utils/Head";
import { Navbar } from "../Layout/Navbar";

export const Practices = () => {
  const [showModal, setShowModal] = useState(false);
  const url = "https://youtu.be/D9gRJv5KbuQ";

  return (
    <>
      <Head title="Practices" description="Practices - Mairini" />
      <div className={css.container}>
        <Navbar />
        <section className={css.audioTop}>
          <h1>Práticas</h1>
        </section>

        <section className={css.audioContent}>
          <div className={css.audioContainer}>
            <div className={css.card} onClick={() => setShowModal(true)}>
              <h2>Orientações para as práticas terapêuticas</h2>
            </div>
            <div
              className={css.card}
              onClick={() => window.open(url, "_blank")}
            >
              <h2>Prática para dormir</h2>
              <iframe
                src="https://www.youtube.com/embed/sBSNGBIwVLw?si=nXU2ZD0AkQgrwMKE"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
            <div
              className={css.card}
              onClick={() => window.open(url, "_blank")}
            >
              <h2>Prática terapêutica antes do trabalho</h2>
              <iframe
                src="https://www.youtube.com/embed/D9gRJv5KbuQ?si=GPt8XFCFEeqk4sY7"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
            <div
              className={css.card}
              onClick={() => window.open(url, "_blank")}
            >
              <h2>Prática: Ouvindo a chuva</h2>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/nPruxQl1HFQ?si=WrzdOaUP75CueHTS"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
            <div
              className={css.card}
              onClick={() => window.open(url, "_blank")}
            >
              <h2>Prática: Ouvindo a Praia 15 minutos</h2>
              <iframe
                src="https://www.youtube.com/embed/lmeeVqDjvVw?si=lBPfdrmlkieJoHxO"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </section>
        <footer className={css.footer}>
          {/* <div className={css.footerLinks}>
                    <a href="#">Privacidade</a>
                    <a href="#">Termos de uso</a>
                  </div> */}
          {/* <div className={css.footerSocial}>
                    <a href="#">
                      <ion-icon
                        name="logo-facebook"
                        className="icon"
                        alt="Facebook"
                      ></ion-icon>
                    </a>
                    <a href="#">
                      <ion-icon
                        name="logo-twitter"
                        className="icon"
                        alt="Twitter"
                      ></ion-icon>
                    </a>
                    <a href="#">
                      <ion-icon
                        name="logo-linkedin"
                        className="icon"
                        alt="LinkedIn"
                      ></ion-icon>
                    </a>
                  </div> */}
          <div className={css.footerContact}>
            {/* <p>Email: info@educationalplatform.com</p> */}
            {/* <p>Phone: +55 61 92492842</p> */}
          </div>
          <div className={css.newsletterSignup}>Mairini © 2025</div>
        </footer>
      </div>
      {showModal && (
        <div className={css.modalContainer}>
          <div className={css.modal}>
            <header className={css.modalHeader}>
              <span
                onClick={() => {
                  setShowModal(false);
                }}
                className={`material-icons ${css.materialIcon} ${css.materialButton}`}
              >
                close
              </span>
            </header>
            <div className={css.modalBody}>
              <div>
                <h4>Orientações para aproveitar melhor a prática</h4>
                <p>
                  A prática guiada é um convite para estar presente com o que
                  quer que surja — pensamentos, emoções, sensações — sem tentar
                  controlar ou evitar a experiência. Abaixo, algumas dicas para
                  te apoiar nessa prática:
                </p>
                <h4>1. Não tente “fazer certo”</h4>
                <p>
                  A mente vai se distrair, e isso é natural. Quando perceber que
                  se perdeu em pensamentos, apenas reconheça isso com gentileza
                  e volte sua atenção para a voz, a respiração ou o corpo. Cada
                  vez que você retorna, está fortalecendo a habilidade de se
                  reconectar com o momento presente.
                </p>
                <h4>2. Dê espaço para o desconforto</h4>
                <p>
                  Nem toda prática terapêutica vai ser relaxante — e tudo bem.
                  Se surgirem emoções difíceis, observe-as com curiosidade, como
                  se estivesse abrindo espaço para que elas estejam ali, sem
                  lutar contra. Isso é parte do processo de aceitação.
                </p>
                <h4>3. Observe os pensamentos, não entre na conversa</h4>
                <p>
                  Pensamentos virão. Em vez de se envolver com eles, experimente
                  apenas notá-los — como se fossem nuvens passando no céu ou
                  carros passando por uma rua. Você pode ouvi-los sem precisar
                  acreditar em tudo o que dizem.
                </p>
                <h4>4. Traga uma postura de abertura e compaixão</h4>
                <p>
                  Você não precisa se esforçar para “esvaziar a mente” ou se
                  sentir de um certo jeito. O convite é estar com você mesmo, do
                  jeito que estiver, com gentileza e curiosidade. Essa prática
                  não busca se livrar do que você sente, mas se aproximar com
                  cuidado.
                </p>
                <h4>5. Relembre o porquê você está praticando</h4>
                <p>
                  Talvez você queira cuidar melhor de si, lidar com a ansiedade,
                  cultivar mais presença ou viver com mais leveza. Mantenha
                  esses valores em mente — eles podem te ajudar a persistir
                  mesmo nos dias em que for mais difícil.
                </p>
                <h4>6. Dê tempo para a prática se revelar</h4>
                <p>
                  Os efeitos da prática costumam aparecer aos poucos, como o
                  crescimento de uma planta. Vá com paciência, constância e sem
                  pressa. Mesmo alguns minutos por dia já fazem diferença.
                </p>
              </div>

              <footer className={css.modalFooter}>
                <button
                  className="defaultButton"
                  onClick={(e) => {
                    setShowModal(false);
                  }}
                >
                  Fechar
                </button>
              </footer>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
